export const formatUrlForDisplay = (url: string): string => {
  return url.replace(/^(https?:\/\/)?(dev-sdemo\.nextlevel\.ai\/)?/, '');
};
